export default __webpack_public_path__ + "static/media/michael-ryzhov.72022364.jpg";